export enum ECartRoute {
  multiCart = '/carts',
  makingOrderDetails = '/cart/making-order-details',
}
